jQuery(document).ready(function ($) {
  var players = {};
  var sliderInitialised = false;

  // ✅ Detect iOS and show the button
  function isIOS() {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ); // iPad OS 13+
  }

  function showUnmuteBtn(index) {
    var $slide = $(
      '.js-video-shorts-carousel .slick-slide[data-slick-index="' +
        index +
        '"]',
    );
    $slide.find(".ios-muted-button").fadeIn(200);
  }
  function hideAllUntmuteBtns() {
    $(".ios-muted-button").fadeOut(200);
  }

  

    // let videoUrl;

    // if ($(".js-video-modal-toggle-carousel").hasClass("short")) {
    //   videoUrl =
    //     embedUrl +
    //     videoCode +
    //     "?&title=0&description=0&autoplay=1&muted=0&texttrack=en";
    //   console.log("short");
    // }

    // const width = "100%";
    // const height = "100%";

    // const iframe = $("<iframe>", {
    //   src: videoUrl,
    //   width: width,
    //   height: height,
    //   frameborder: 0,
    //   allowfullscreen: true,
    //   webkitallowfullscreen: true,
    //   mozallowfullscreen: true,
    //   id: "vimeo_video",
    //   allow: "autoplay; fullscreen",
    //   "data-video-code": videoCode,
    // });

  // ── Build slider slides and modal list from main list links
  function buildModal(clickedVideoId) {
    var $sliderWrap = $(".js-video-shorts-carousel");

    // Clear previous content

    // Destroy slick if already initialised
    if (sliderInitialised) {
      $sliderWrap.slick("unslick");
      sliderInitialised = false;
    }

    $sliderWrap.empty();

    var slideIndex = 0;
    var targetIndex = 0;

    // Loop each main list item and build slides
    $(".c-video-card__parent .c-video-card--link").each(function (i) {
      var $link = $(this);
      var vimeoId = $link.data("vimeo-code");
      var videoId = $link.data("video-id");
      var iframeId = "modal-vimeo-" + videoId;

      // Track which slide to start on
      if (videoId === clickedVideoId) {
        targetIndex = slideIndex;
      }

      // Build slide
      var $slide = $(
        '<div class="c-video-carousel__slide slide">' +
          '<div class="c-video-carousel__container">' +
          '<iframe id="' +
          iframeId +
          '" ' +
          'src="https://player.vimeo.com/video/' +
          vimeoId +
          "?&texttrack=en&api=1&player_id=" +
          iframeId +
          '" ' +
          'allow="autoplay; fullscreen" allowfullscreen>' +
          "</iframe>" +
          '<button class="ios-muted-button" style="display:none;">Unmute</button></div>' +
          "</div>" +
          "</div>",
      );

      $sliderWrap.append($slide);

      slideIndex++;
    });

    // Init Slick
    $sliderWrap.slick({
      vertical: true,
      verticalSwiping: true,
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      cssEase: "ease-in-out",
      appendArrows: ".c-slider__arrows",
      infinite: false,
      initialSlide: targetIndex,
      swipeToSlide: true,
    });
    sliderInitialised = true;

    // Init Vimeo players after slick is ready
    $sliderWrap.find("iframe").each(function () {
      var id = $(this).attr("id");
      var player = new Vimeo.Player(this);
      players[id] = player;

      // Advance to next slide when video ends
      player.on("ended", function () {
        $sliderWrap.slick("slickNext");
      });
    });

    $sliderWrap
      .off("afterChange")
      .on("afterChange", function (event, slick, currentSlide) {
        pauseAllVideos();
        // hideAllUntmuteBtns();
        playSlideVideo(currentSlide);
      });

    // Set active state on modal list
    // setActiveListItem(targetIndex);

    // Play the target video
    // playSlideVideo(targetIndex);
    return targetIndex;
  }

  // ── Pause all players
  function pauseAllVideos() {
    $.each(players, function (id, player) {
      player.pause();
    });
  }

  // ── Play the video at a given slide index
  function playSlideVideo(index) {
    var $slide = $(
      '.js-video-shorts-carousel .slick-slide[data-slick-index="' +
        index +
        '"]',
    );
    var $iframe = $slide.find("iframe");
    if ($iframe.length) {
      var id = $iframe.attr("id");
      if (players[id]) {
        players[id].setVolume(1).then(function () {
          players[id].play();
        });
        // if (isIOS()) {
        //   showUnmuteBtn(index);
        // }
        // players[id].play();
      }
    }
  }

  // ── Main list link clicked — open modal
  $(".js-video-modal-toggle-carousel").on("click", function (e) {
    e.preventDefault();

    $("body").addClass("overflow-hidden");

    var clickedVideoId = $(this).data("video-id");
    var targetIndex = buildModal(clickedVideoId);
    console.log(clickedVideoId);
    buildModal(clickedVideoId);

    var modal = $("#video-modal");
    modal.removeClass("is-closed out");
    modal.children().removeClass("is-closed out");

    playSlideVideo(targetIndex);
  });

  function modalOverlayClose() {
    $(".c-modal-overlay--vimeo-video").on("click", function (e) {
      pauseAllVideos();
      hideAllUntmuteBtns();
      $("#video-modal").find(".c-video-carousel").empty();
      $("#video-modal").addClass("is-closed out");
      $("#video-modal").siblings().addClass("is-closed out");
      $("body").removeClass("overflow-hidden");
    });
  }
  modalOverlayClose();

  $(".c-modal__close--vimeo-video").on("click", function (e) {
    hideAllUntmuteBtns();
    $(".js-video-shorts-carousel").slick("unslick");
    $("#video-modal")
      .find(".c-video-carousel")
      .empty()
      .removeClass("slick-vertical");
    $("#video-modal").addClass("is-closed", "out");
    // $(this).parent().find(".video-short-modal").empty();
    $("body").removeClass("overflow-hidden");
  });

  // ── Close on Escape key
  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      pauseAllVideos();
      $("#video-modal").find(".c-video-carousel").empty();
      $("#video-modal").addClass("is-closed", "out");
    }
  });

  $(".c-slider__arrows").on("click", ".slick-prev, .slick-next", function () {
    pauseAllVideos();

    setTimeout(function () {
      var currentIndex = $(".js-video-shorts-carousel").slick(
        "slickCurrentSlide",
      );

      playSlideVideo(currentIndex);
    }, 500);
  });

  $(document).on("click", ".ios-muted-button", function () {
    var $btn = $(this);
    var $iframe = $btn.siblings("iframe");
    var id = $iframe.attr("id");

    if (players[id]) {
      players[id]
        .setMuted(false)
        .then(function () {
          return players[id].setVolume(1);
        })
        .then(function () {
          $btn.fadeOut(200); // ✅ hide button once unmuted
        })
        .catch(function (err) {
          console.warn("Could not unmute:", err);
        });
    }
  });
});
